<template>
  <v-layout row wrap fill-height>
    <v-flex v-if="share && ticket && status">
      <v-card class="mb-3 sticky-element" :class="stickyClass">
        <v-layout row class="pa-2">
          <v-flex xs12>
            <v-layout row>
              <v-flex xs12 sm3 md2 lg1 class="text-xs-center ticket-number" :style="{'border-color': status.color}">
                <h1 :style="{'color': status.color}">{{ticket.sequential_id}}</h1>
              </v-flex>
              <v-flex xs8 class="grey--text">
                <h1 class="grey--text text--darken-2 text-truncate text-nowrap text-xs-left pa-2">
                  {{ticket.title}}
                </h1>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row class="pb-3">
          <v-flex xs6>
            <v-layout row>
              <v-flex xs4 class="text-uppercase text-xs-right pt-2">
                <h3>Created at</h3>
              </v-flex>
              <v-flex xs8 class="pl-3 pt-2">
                {{ ticket.created_at | formatDateAgo }} on {{ ticket.created_at | formatDateLong}}
              </v-flex>
            </v-layout>
            <v-layout row v-if="email">
              <v-flex xs4 class="text-uppercase text-xs-right pt-2">
                <h3>Email received</h3>
              </v-flex>
              <v-flex xs8 class="pl-3 pt-2">
                {{ email.created_at | formatDateAgo }} on {{ email.created_at | formatDateLong}}
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs4 class="text-uppercase text-xs-right pt-2">
                <h3>Current status</h3>
              </v-flex>
              <v-flex xs8 class="pl-3 pt-2">
                <v-chip :color="status.color" outline small>
                  {{ status.name }}
                 </v-chip>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs6 v-show="attachments.length > 0">
            <h3>Attachments</h3>
            <span v-for="(att, idx) in attachments" :key="idx">
              <v-tooltip bottom>
                {{att.filename}}
                <v-chip disabled small outline slot="activator">
                  <a :href="auth.decorate_path_with_access_params(att.download_url)" target="attachments">
                    {{att.filename.substr(0,15)}} | {{att.filesize | toFileSize}}
                  </a>
                </v-chip>
              </v-tooltip>
            </span>
          </v-flex>
        </v-layout>
      </v-card>

      <div v-for="(comment, idx) in comments" class="mb-3" :key="idx">
        <comment :comment="comment" :ticket="ticket" :status="status" :key="comment.id"></comment>
      </div>
    </v-flex>

    <template v-else-if="notFound">
      <v-flex class="xs12 sm6 text-xs-center" >
        <h1 class="mb-5">Not found</h1>
        <p>We could not find the ticket you are looking for. Please check your link to make sure your access token is correct, or contact the team who shared it with you.</p>
      </v-flex>
      <v-flex class="xs12 sm6 not-found">
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
  import { debounce } from 'debounce'
  import authentication from '@/utilities/authentication'

  import shareService from '@/services/share'

  import shareComment from '@/components/share/_comment'

  export default {
    name: 'share-show',

    components: {
      comment: shareComment
    },

    props: ['token'],

    data () {
      return {
        auth: authentication,
        share: null,
        ticket: null,
        status: null,
        comments: [],
        email: null,
        scroll: 0,
        notFound: null
      }
    },

    created: function () {
      // document.addEventListener('mousewheel', this.onScroll)
      document.addEventListener('scroll', this.onScroll)
    },

    destroyed: function () {
      // document.removeEventListener('mousewheel', this.onScroll)
      document.removeEventListener('scroll', this.onScroll)
    },

    computed: {
      stickyClass () {
        if (window.innerWidth > 599) {
          if (this.scroll > 0) {
            return 'elevation-8'
          } else {
            return ''
          }
        }
      },

      attachments () {
        return this.comments.map(c => c.attachments).flat().sort((a, b) => a.filename.localeCompare(b.filename))
      }
    },

    mounted () {
      this.loadShare()
    },

    watch: {
    },

    methods: {
      loadShare () {
        if (this.token) {
          shareService.show(
            (data) => {
              this.ticket = Object.assign({}, data.ticket)
              this.status = Object.assign({}, data.status)
              this.comments = Object.assign([], data.comments)
              this.share = Object.assign({}, data.attributes)
              if (data.email) {
                this.email = Object.assign({}, data.email)
              }
            },
            (err) => {
              console.log(err)
              this.notFound = true
            },
            this.token
          )
        }
      },

      onScroll: debounce(function (event) {
        if (!this.allCommentsLoaded) {
          this.loadComments()
        }
      }, 500)
    }
  }
</script>

<style lang="scss" scoped>
  .v-speed-dial {
    bottom: 160px;
    right: 72px;

    .v-speed-dial__list .v-tooltip {
      display: block;
      margin: 0 auto;
    }
  }

  .ticket-number {
    border: 3px solid;
    border-radius: 0%;
  }

  @media screen and (min-width: 600px) {
    .sticky-element{
      position: sticky;
      position: -webkit-sticky;
      top: 5px;
      z-index: 5;
    }
  }

  .attachment-list {
    max-height: 4.3em;
    overflow-y: scroll;
  }

  .not-found {
    background: url('../../assets/oops.jpg') no-repeat center;
    background-size: contain;
  }
</style>



// WEBPACK FOOTER //
// src/components/share/show.vue